export default __webpack_public_path__ + "static/media/chevron-down.b052dd29.svg";